import { compose } from "redux";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";

import { moneyFormater } from "../../../../../utilities/formaters";
import { accountBalanceConnector } from "../../../../../services/menu/dashboard/account.balance.connector";

const LoanstepAccountBalance = (props) => {
  const currency = props.currency;

  const lsBalanceFetched =
    props.accountBalance[currency].lsFetched &&
    !props.accountBalance[currency].lsFetching;

  if (lsBalanceFetched) {
    let lsData = props.accountBalance[currency].lsData;

    let lsCash = lsData.LoanstepCash.Amount;
    let borRecon = lsData.BorrowerRecon.Amount;
    let borDep = lsData.BorrowerDepots.Amount;

    return (
      <div>
        <Card
          style={{
            width: "50%",
            whiteSpace: "normal",
            display: "inline-block",
          }}
        >
          <CardHeader title="Loanstep account balances" />
          <CardContent>
            <strong>Cash</strong>:{" "}
            {moneyFormater(Math.floor(lsCash * 100) / 100)} {currency}
            <br />
            <strong>Borrower recon</strong>:{" "}
            {moneyFormater(Math.floor(borRecon * 100) / 100)} {currency}
            <br />
            <strong>Borrower depots</strong>:{" "}
            {moneyFormater(Math.floor(borDep * 100) / 100)} {currency}{" "}
            (overpayments)
            <br />
          </CardContent>
        </Card>
      </div>
    );
  }
  return <div>Loading</div>;
};

export default compose(accountBalanceConnector)(LoanstepAccountBalance);
